import { TablePaginationConfig } from 'antd/lib/table';
import { useEffect } from 'react';

const useScrollTopPage = (pagination: TablePaginationConfig) => {
  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [pagination]);
};

export default useScrollTopPage;
